import { render, staticRenderFns } from "./servicePrice.vue?vue&type=template&id=443e4020&scoped=true"
import script from "./servicePrice.vue?vue&type=script&lang=js"
export * from "./servicePrice.vue?vue&type=script&lang=js"
import style0 from "./servicePrice.vue?vue&type=style&index=0&id=443e4020&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443e4020",
  null
  
)

export default component.exports